var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignIn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.5C10 9.67157 10.6716 9 11.5 9H16C16.2761 9 16.5 9.22386 16.5 9.5C16.5 9.77614 16.2761 10 16 10H11.5C11.2239 10 11 10.2239 11 10.5V21.5C11 21.7761 11.2239 22 11.5 22H16C16.2761 22 16.5 22.2239 16.5 22.5C16.5 22.7761 16.2761 23 16 23H11.5C10.6716 23 10 22.3284 10 21.5V10.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3999 12.1452C17.194 11.9516 16.8603 11.9516 16.6544 12.1452C16.4485 12.3387 16.4485 12.6525 16.6544 12.846L19.5 15.5L12.5 15.5C12.2239 15.5 12 15.7239 12 16C12 16.2761 12.2239 16.5 12.5 16.5L19.4772 16.5L16.6544 19.154C16.4485 19.3475 16.4485 19.6613 16.6544 19.8548C16.8603 20.0484 17.194 20.0484 17.3999 19.8548L21.5 16L17.3999 12.1452Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIn);
export default __webpack_public_path__ + "static/media/sign_in.e774f9ee9580495998c6ca8afca38b7e.svg";
export { ForwardRef as ReactComponent };